/** @format */

export function normalizePolicyCountries(data) {
    const ret = { ...data };
    ret.options = data.options.map((option) => ({
        name: option.country_name,
        value: option.country_code,
        uid: option.uid,
        url: option.url.url || undefined,
    }));
    return ret;
}
